var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoshjidLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.8889C3 5.97969 7.02944 2 12 2C16.9706 2 21 5.97969 21 10.8889C21 16.2006 15.929 20.041 12.7799 21.6333C12.2877 21.8821 11.7123 21.8821 11.2201 21.6333C8.07101 20.041 3 16.2006 3 10.8889ZM12.0002 6C11.8179 5.99994 11.6356 6.08691 11.5262 6.26089L10.6492 7.65547C10.5507 7.81197 10.3804 7.90964 10.1947 7.91603L8.53996 7.97297C8.12722 7.98717 7.87216 8.42586 8.06615 8.78792L8.84385 10.2394C8.93113 10.4023 8.93113 10.5977 8.84385 10.7606L8.06615 12.2121C7.87216 12.5741 8.12722 13.0128 8.53996 13.027L10.1947 13.084C10.3804 13.0904 10.5507 13.188 10.6492 13.3445L11.5262 14.7391C11.7449 15.087 12.2551 15.087 12.4738 14.7391L13.3508 13.3445C13.4493 13.188 13.6196 13.0904 13.8053 13.084L15.46 13.027C15.8728 13.0128 16.1278 12.5741 15.9339 12.2121L15.1561 10.7606C15.0689 10.5977 15.0689 10.4023 15.1561 10.2394L15.9339 8.78792C16.1278 8.42586 15.8728 7.98717 15.46 7.97297L13.8053 7.91603C13.6196 7.90964 13.4493 7.81197 13.3508 7.65547L12.4738 6.26089C12.3645 6.08702 12.1823 6.00006 12.0002 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoshjidLocation);
export default __webpack_public_path__ + "static/media/moshjid-location.8d2729dfffc4af9cf257f330aa40a337.svg";
export { ForwardRef as ReactComponent };